import React from 'react'

import { SortMenu } from '~/components/maple/filters/sort-menu'
import { TagsPicker } from '~/components/maple/filters/tags-picker'

export const TopFilters = ({
  className,
  brandsOptions,
  categoriesOptions,
  earnRatesOptions,
  headerComponent,
  sortComponent,
}: {
  className?: string
  brandsOptions?: any[]
  categoriesOptions?: any[]
  earnRatesOptions?: any[]
  headerComponent?: React.ReactNode
  sortComponent?: React.ReactNode
}) => {
  return (
    <div>
      <div className="flex flex-row items-center justify-between rounded-md py-2">
        {headerComponent}
        {sortComponent ?? <SortMenu />}
      </div>
      <div>
        <TagsPicker
          brandOptions={brandsOptions}
          categoryOptions={categoriesOptions}
          earnRateOptions={earnRatesOptions}
        />
      </div>
    </div>
  )
}
